<section class="expired">
  <img
    src="assets/images/verify_invalid_cpf_user.svg"
    width="200"
    alt="seguranca"
  />

  <div class="expired__title">
    <strong class="text-blue">Ops...</strong> Parece que esse link já expirou!
  </div>

  <p>
    <strong>Teve algum problema ou ficou com alguma dúvida?</strong>
    Entre em contato com o agente ou pelo suporte Omni.
  </p>

  <p>Contatos: 0800 727 0885 <br />0800 727 0885</p>
</section>
